import { render, staticRenderFns } from "./CompatibleVideo.vue?vue&type=template&id=177ed4cd&scoped=true"
import script from "./CompatibleVideo.vue?vue&type=script&lang=js"
export * from "./CompatibleVideo.vue?vue&type=script&lang=js"
import style0 from "./CompatibleVideo.vue?vue&type=style&index=0&id=177ed4cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177ed4cd",
  null
  
)

export default component.exports